export default {"src":"/_next/static/media/hamburger-menu-dark.b9cc8b9b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};